/**
 * @generated SignedSource<<e96085bbcce137ceef5bbc2a3193bcb7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cplId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VendorCommProgramLineDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteCpLineTPayload",
        "kind": "LinkedField",
        "name": "deleteCpLineTByCplId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CpLineT",
            "kind": "LinkedField",
            "name": "cpLineT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VendorCommProgramLineDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteCpLineTPayload",
        "kind": "LinkedField",
        "name": "deleteCpLineTByCplId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CpLineT",
            "kind": "LinkedField",
            "name": "cpLineT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2c866e6ac882d1881dee63e74fc12cfe",
    "id": null,
    "metadata": {},
    "name": "VendorCommProgramLineDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation VendorCommProgramLineDeleteMutation(\n  $input: DeleteCpLineTByCplIdInput!\n) {\n  deleteCpLineTByCplId(input: $input) {\n    cpLineT {\n      cplId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "79feebc827ebb2901125c2485d96333e";

module.exports = node;
